//Số thuế phải nộp trên tờ khai điều chỉnh tăng/giảm:
export default {
  GTGTDomesticProductionAndTrading: 1701,
  GTGTImport: 1702,
  GTGTOilExplorationAndProduction: 1704,
  GTGTLottery: 1705,
  OtherService: 1749,
};
